import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import { TwoFAType } from 'pages/MyAccountEdit/types'
import { useCurrentUser } from 'utils/hooks/useCurrentUser'

type Props = {
  editable?: boolean
}

export const TwoFactorAuthButton = ({ editable }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const user = useCurrentUser()

  if (!editable) {
    return (
      <Typography
        component="span"
        color="primary"
        sx={(theme) => ({
          fontSize: theme.typography.h4.fontSize,
          lineBreak: 'anywhere',
          fontWeight: 'bold',
        })}
      >
        {user?.two_factor_authentication
          ?.map((type) => t(`profile.two_factor_authentication.${type || TwoFAType.unknown}`))
          ?.join(', ') || t(`profile.two_factor_authentication.${TwoFAType.unknown}`)}
      </Typography>
    )
  }

  return (
    <>
      <Typography
        component="span"
        color="primary"
        sx={(theme) => ({
          cursor: 'initial',
          fontSize: theme.typography.h4.fontSize,
          lineBreak: 'none',
          textDecoration: 'none',
          fontWeight: 'bold',
        })}
      >
        {user?.two_factor_authentication
          ?.map((type) => t(`profile.two_factor_authentication.${type || TwoFAType.unknown}`))
          ?.join(', ') || t(`profile.two_factor_authentication.${TwoFAType.unknown}`)}{' '}
      </Typography>
      <Typography
        component="span"
        color="primary"
        sx={(theme) => ({
          cursor: 'pointer',
          fontSize: theme.typography.h4.fontSize,
          lineBreak: 'anywhere',
          textDecoration: 'underline',
          fontWeight: 'bold',
        })}
        onClick={() => navigate('/my-account/2fa')}
      >
        ({t('app.change')})
      </Typography>
    </>
  )
}
